<template>
    <div v-if="fetcher.initialized">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body">

            <div class="container-fluid">
                <h1 class="mb-4">{{ pageTitle }}</h1>
                <p class="large-text">Köp ett nytt klippkort hos oss eller via din förmånsportal.</p>

                <div class="list mt-8">

                    <a href="https://halsoresurs.se/shop/?utm_source=app&utm_medium=shop_page&utm_campaign=App+shop+page&utm_id=app_shop_page" target="_blank" class="list-item portal d-flex justify-content-between align-items-center" :class="{ 'last-portal' : last_sales_portal == 'webshop' }" @click="matomoTrackEvent('Shop', 'Portal', 'Webshop')">
                        <div style="width:calc(100% - 30px);">
                            <h3 class="mb-2">Köp hos Hälsoresurs</h3>
                            
                            <img style="width:180px; height:21px;" src="/images/card/webshop-logos.jpg">
                        </div>
                        <div style="width:20px;">
                            <img src="/images/card/list-headline-arrow-primary.svg" class="float-end" style="height:20px;">
                        </div>
                    </a>

                    <a :href="portal.url" target="_blank" class="list-item portal d-flex justify-content-between align-items-center" :class="{ 'last-portal' : last_sales_portal == portal.key }" @click="matomoTrackEvent('Shop', 'Portal', portal.key )" v-for="portal in portals">
                        <div style="width:calc(100% - 30px);">
                            <img style="width:110px; height: 37px;" :src="'/images/card/'+portal.logo">
                            <span class="last-portal-label">Min portal</span>
                        </div>
                        <div style="width:20px;">
                            <img src="/images/card/list-headline-arrow-primary.svg" class="float-end" style="height:20px;">
                        </div>
                    </a>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import scrollMixin from '../../../shared/mixins/scrollMixin'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        scrollMixin,
        fetcher
    ],

    components: {},

    data () {
        return {
            pageTitle: 'Köp klippkort',

            last_sales_portal: null,
            fetcher: {
                autoFill: [
                    'last_sales_portal'
                ]
            },
            portals: {
                benify: {
                    key: 'benify',
                    logo: 'portal-benify.png',
                    url: 'https://www.benify.com/fps/goTo/global?goToPage=*benefit***897'
                },
                epassi: {
                    key: 'epassi',
                    logo: 'portal-epassi.png',
                    url: 'https://services.epassi.se/ui/merchant-search?benefitType=WELLNESS&searchParams=H%C3%A4lsoresurs'
                },
                soderberg: {
                    key: 'soderberg',
                    logo: 'portal-soderberg.png',
                    url: 'https://signin.soderbergpartners.se/prompt?signin=nPzrRAkNfWODVdsO'
                },
                wellnet: {
                    key: 'wellnet',
                    logo: 'portal-wellnet.png',
                    url: 'https://portalen.wellnet.se/Company/Show/6334'
                }
                /*,
                edenred: {
                    key: 'edenred',
                    logo: 'portal-edenred.png',
                    url: 'https://halsoresurs.se/shop/?c=288fb88cac179613ff4a72c8a8622c6c'
                }
                */
            },
        }
    },

    computed: {
        fetcherUrl () {
            return '/shop'
        }
    },

    methods: {

    }
}
</script>
